module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Bullet-list-faf1dc26c729d4bd9af07687e8452dd0.svg";